import $ from '../../plugins/query';

export default class ToggleSlideController {
    constructor() {
        this.BTN = '.btn-toggle-slide';
        this.registerEventListener();
    }

    registerEventListener() {
        $(this.BTN).on('click', (e) => {
            const { target } = e.currentTarget.dataset;
            $(target).slideToggle(500);
            $(event.currentTarget).toggleClass('open');
        });
    }

    static init() {
        document.addEventListener('DOMContentLoaded', () => {
            new ToggleSlideController(); // eslint-disable-line no-new
        });
    }
}
